module.exports = __webpack_public_path__ + "static/logo-pertamina-8bd891000546d01270fe972615cc405e.png";